import { render, staticRenderFns } from "./HostingPhp.vue?vue&type=template&id=4e6ca32f&"
import script from "./HostingPhp.vue?vue&type=script&lang=js&"
export * from "./HostingPhp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports